import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { TranslationKeyConstants } from '../constants/translation-key-constants';
import { FlxMessageService } from "@fluxys/primeng";

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private readonly httpClient = inject(HttpClient);
  private readonly messageService = inject(FlxMessageService);


  showSuccessMessage(messageKey: string): void {
    this.messageService.showSuccessToast(
      {
        key: messageKey,
      },
      TranslationKeyConstants.shared.successMessages.title,
      true,
      3000,
      true,
    );
  }
  showInfoMessage(messageKey: string): void {
    this.messageService.showInfoToast(
      {
        key: messageKey,
      },
      TranslationKeyConstants.shared.successMessages.title,
      true,
      3000,
      true,
    );
  }

  showErrorMessage(messageKey: string, params?:  Readonly<Record<string, string>>): void {
    this.messageService.showErrorToast(
      {
        key: messageKey,
        data: params
      },
      TranslationKeyConstants.shared.errorMessages.title,
      true,
      3000,
      true,
    );
  }
}
